import { SVGAttributes, FC } from 'react';
import Lottie from 'react-lottie';
import marketing from './animations/marketing.json';
import success from './animations/success.json';
import somethingWentWrongEmoji from './animations/something-went-wrong-emoji.json';
import loader from './animations/loader.json';
import gear from './animations/gear.json';
import failed from './animations/failed.json';
import sandClock from './animations/sand-clock.json';
import empty from './animations/empty.json';
import graph from './animations/graph.json';

type VariantOptions =
  | 'marketing'
  | 'success'
  | 'loader'
  | 'gear'
  | 'somethingWentWrongEmoji'
  | 'failed'
  | 'sand-clock'
  | 'empty'
  | 'graph';

export interface Props extends SVGAttributes<SVGElement> {
  variant: VariantOptions;
  loop: boolean;
}

// create a mapping between the passed variant and the associated json file
const variants = {
  marketing,
  success,
  somethingWentWrongEmoji,
  loader,
  gear,
  failed,
  'sand-clock': sandClock,
  empty,
  graph,
};

const LottieAnimation: FC<Props> = ({ variant, loop = false }: Props) => {
  return (
    <Lottie
      options={{
        animationData: variants[variant],
        loop,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      isClickToPauseDisabled
    />
  );
};

export default LottieAnimation;
